module.exports = __webpack_public_path__ + "static/media/Rejina-Pya-Greta-puff-dress_thumb.9e6c33a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/some-extra- womenswear- product-shots/thumbs/Rejina-Pya-Greta-puff-dress_thumb.png
// module id = 324
// module chunks = 0